module.exports = __webpack_public_path__ + "static/media/luohanshan_plant.cfd0bdfa.png";